export { VpVideoPlayer } from './VpVideoPlayer';



// WEBPACK FOOTER //
// ./src/vp-ui/components/VpVideoPlayer/index.js